<template>

    <div class="tool-container-preview-toolbar">

        <div class="tool-container-preview-toolbar__options-form">

            <b-btn variant="default"
                   v-b-toggle="'format-options'">
                <open-icon name="chevron-bottom" v-if="optionsVisible"></open-icon>
                <open-icon name="chevron-right" v-if="!optionsVisible"></open-icon>
                Formatting Options
            </b-btn>

            <b-collapse class="format-options" id="format-options"
                        v-model="optionsVisible">
                <b-card no-body>
                    <b-card-body>
                        <!-- options form -->
                        <b-form inline>
                            <!-- universal options -->
                            <b-form-group class="mr-3"
                                          label="Font Style">
                                <b-form-select v-model="docData.fontFace">
                                    <option value="sans">Sans Serif</option>
                                    <option value="serif">Serif</option>
                                    <option value="mono">Monospace</option>
                                </b-form-select>
                            </b-form-group>
                            <b-form-group class="mr-3"
                                          label="Font Size">
                                <b-form-select v-model="docData.fontSize">
                                    <option value="small">Small</option>
                                    <option value="large">Large</option>
                                </b-form-select>
                            </b-form-group>

                            <!-- tool-specific options -->
                            <b-form-group class="mr-3"
                                          :class="{'textarea-form-group': opt.type == 'textarea'}"
                                          :label="opt.label"
                                          v-for="opt in tool.options.exportOptions">
                                <b-form-select v-if="opt.type == 'bool'"
                                               v-model="docData[opt.name]"
                                               :options="[{value: true, text: 'Yes'}, {value: false, text: 'No'}]">
                                </b-form-select>
                                <b-form-textarea v-if="opt.type == 'textarea'"
                                                 v-model="docData[opt.name]">
                                </b-form-textarea>
                            </b-form-group>

                        </b-form>

                        <div class="format-options__buttons">
                            <b-btn variant="primary" class="ml-2"
                                   @click="print()">
                                Print
                            </b-btn>
                            <b-btn variant="primary" class="ml-2"
                                   v-if="downloadDocFile"
                                   @click="downloadDocFile()">
                                Create .docx
                            </b-btn>
                            <b-btn variant="primary" class="ml-2"
                                   v-if="downloadPdfFile"
                                   @click="downloadPdfFile()">
                                Create .pdf
                            </b-btn>
                          <b-btn variant="primary" class="ml-2"
                                 v-if="exportToGoogleForms"
                                 @click="exportToGoogleForms()">
                              <span v-show="!createFormLoading">
                                  Create Google Form
                              </span>
                              <span v-show="createFormLoading">
                                  <b-spinner small label="Creating Form..." class="form-spinner"></b-spinner>
                                  <span>Creating Form...</span>
                              </span>
                          </b-btn>
                        </div>

                    </b-card-body>
                </b-card>

            </b-collapse>
        </div>

        <div class="tool-container-preview-toolbar__created-forms" v-if="exportToGoogleForms">
            <b-btn variant="default"
                   v-b-toggle="'forms-list'">
                <open-icon name="chevron-bottom" v-if="formsVisible"></open-icon>
                <open-icon name="chevron-right" v-if="!formsVisible"></open-icon>
                Created Google Forms
            </b-btn>

            <b-collapse id="forms-list"
                        v-model="formsVisible">
                <b-card no-body>
                    <b-card-body>
                        <table class="form-list" no-body>
                            <tr>
                                <th class="created">Created</th>
                                <th class="actions">Actions</th>
                            </tr>
                            <tr v-for="form in docData.createdForms" :key="form.formId">
                                <td class="created">{{form.createdTime}}</td>
                                <td class="actions">
                                    <b-button variant="primary" class="ml-2 form-action-button" :href="form.respondLink" target="_blank">
                                        View
                                    </b-button>
                                    <b-button variant="primary" class="ml-2 form-action-button" :href="form.editLink" target="_blank">
                                        Edit
                                    </b-button>
                                    <b-button variant="danger" class="ml-2 form-action-button" @click="deleteForm(form.formId)">
                                        <span v-show="!deleteFormLoading || deleteFormLoading != form.formId">
                                            Delete
                                        </span>
                                        <span v-show="deleteFormLoading && deleteFormLoading == form.formId">
                                            <b-spinner small label="Deleting..." class="form-spinner"></b-spinner>
                                            <span class="pl-1">Deleting...</span>
                                        </span>
                                    </b-button>
                                </td>
                            </tr>
                        </table>
                    </b-card-body>
                </b-card>
            </b-collapse>
        </div>

    </div>

</template>

<script>

import Vue from 'vue'
import ToolMixin from '@/providers/ToolMixin'
import ChecklistMakerMixin from '@/providers/ChecklistMakerMixin'

export default Vue.extend({
    name: "ToolContainerPreviewToolbar",
    mixins: [ToolMixin, ChecklistMakerMixin],
    // each tool defines these in the provide section of its mixin...
    inject: ['downloadDocFile', 'downloadPdfFile', 'exportToGoogleForms'],
    props: {
        landscape: Boolean,
    },
    data() {
        return {
            optionsVisible: true,
            formsVisible: true,
        }
    },
    computed: {
        createFormLoading() {
            return this.$store.state.createFormLoading
        },
        deleteFormLoading() {
            return this.$store.state.deleteFormLoading
        }
    },
    methods: {
        print() {
            var css = '@page { size: portrait; }'
            if(this.landscape) {
                var css = '@page { size: landscape; }'
            }
            var style = document.createElement('style');
            style.type = 'text/css';
            style.media = 'print';
            style.appendChild(document.createTextNode(css));
            document.head.appendChild(style);

            window.print()
        },
        deleteForm(id) {
            this.deleteGoogleForm(id)
        }
    }
})
</script>

<style lang="scss">

.tool-container-preview-toolbar {
    margin-bottom: 20px;
}

.tool-container-preview-toolbar__options-form {
    @media print {
        display: none;
    }

    fieldset {
        margin-bottom: 1rem !important;
    }

    .textarea-form-group {
        width: 100%;

        textarea {
            width: 100%;
        }
    }

    .form-spinner {
        margin-right: 5px;
    }
}

.tool-container-preview-toolbar__created-forms {
    @media print {
        display: none;
    }
    .form-list {
        th, td {
            padding-bottom: 10px;
        }
        th.created, td.created {
            justify-content: left;
            padding-right: 300px;
        }
        th.actions, td.actions {
            justify-content: left;
        }
        .form-action-button {
            margin: 5px 0px;
        }
        @media (max-width: 991px) {
            th.created, td.created {
                padding-right: 20px;
            }
        }

    }
}

.format-options__buttons {
    text-align: center;
    padding-top: 1em;
}

</style>
